module.exports = __webpack_public_path__ + "img/client_king.3a2d58e6.jpg";